import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalFooter, Text, VStack } from '@chakra-ui/react';

import DropdownMenu from '../../../../../../components/DropdownMenu';
import StackedButtonGroup from '../../../../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import LoadingSpinner from '../../../../../../components/Spinner';
import { reactivateJob, selectJobProfile, updateJob } from '../../../../../../redux/modules/jobs';
import { hideModal, updateModalOptions } from '../../../../../../redux/modules/modal';
import { activeDepartments } from '../../../../../../utils/departmentUtil';

const TransferArchivedJobModal = () => {
  const dispatch = useDispatch();
  const jobProfile = useSelector(selectJobProfile);
  const { departmentOptions } = jobProfile;

  const [selectedDepartment, setDepartment] = useState(null);
  const [isSubmitting, setSubmitting] = useState(false);

  const handleDepartmentSelect = selected => {
    dispatch(updateModalOptions({ buttons: { primaryButtonOptions: { isDisabled: false } } }));
    setDepartment(selected);
  };

  const handleTransferAndActivate = async () => {
    setSubmitting(true);
    await dispatch(updateJob(jobProfile.jobId, { department_id: parseInt(selectedDepartment.value, 10) }));
    await dispatch(reactivateJob(jobProfile.jobId));
    setSubmitting(false);
    dispatch(hideModal());
  };

  if (!jobProfile) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <VStack spacing={4}>
        <Text color="greyScale.800" textStyle="bodyLg">
          {`The original department, ${jobProfile.department.departmentName}, is archived. To activate ${jobProfile.jobName},
       please transfer the project to an active department`}
        </Text>
        <DropdownMenu
          labelKey="label"
          options={activeDepartments(departmentOptions)}
          selected={selectedDepartment
            ? selectedDepartment.label
            : ''}
          variant="secondary"
          width="380px"
          onSelect={handleDepartmentSelect}
        />
      </VStack>
      <ModalFooter>
        <StackedButtonGroup
          isDisabled={!selectedDepartment}
          isLoading={isSubmitting}
          label="Transfer & Reactivate"
          onClick={handleTransferAndActivate}
        />
      </ModalFooter>
    </>
  );
};

export default TransferArchivedJobModal;
